<script>

  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      subTitle: {
        type: String,
        default: '',
      },
    },
    methods: {
      // openSearch() {
      //   console.log('search')
      //   this.$emit('openSearch')
      // },
      openFilter() {
        this.$emit('openFilter')
      }
    }
  }
</script>
<template>
  <div :class="$style.mobilePageTitle">
    <div class="mobilePageTitle__Box">
      <div class="mobilePageTitle__Inner">
        <h3 class="title font-medium text-2xl">
          {{ title }}
        </h3>
        <div class="searchData__list d-flex color-gray-6  text-sm d-md-none">
          <!-- <div 
            class="saerchData__item text-center isSearch"
            @click="openSearch"
          >
            <i class="fal fa-search text-base"></i>
            <div>搜尋</div>
          </div> -->
          <div 
            class="saerchData__item text-center isFilter"
            @click="openFilter"
          >
            <i class="fal fa-filter text-base"></i>
            <div>篩選</div>
          </div>
        </div>
        <slot/>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .mobilePageTitle {
    min-height: 60px;
    height: 60px;
    // position: relative;
    // z-index: 1220;
    :global {
      .mobilePageTitle {
        // padding: 0;
        // height: 100%;
        &__Inner {
          display: flex;
          justify-content: space-between;
          .saerchData {
            &__list {
              margin-left: 10px;
              flex-shrink: 0;
            }
            &__item {
              &:not(:last-child) {
                margin-right: 30px;
                position: relative;
                &:before {
                  content: '';
                  position: absolute;
                  width: 1px;
                  height: 80%;
                  background: $color-gray-2;
                  top: 50%;
                  transform: translateY(-50%);
                  right: -15px;
                }
              }
            }
          }
          .title {
            align-self: center;
          }
        }
      }
    }
    &:global {
      &.isNoHasFilter {
        .isFilter {
          display: none;
        }
      }
    }
  }
</style>
